import { render, staticRenderFns } from "./SelectSessionsList.vue?vue&type=template&id=01b23916"
import script from "./SelectSessionsList.vue?vue&type=script&lang=js"
export * from "./SelectSessionsList.vue?vue&type=script&lang=js"
import style0 from "./SelectSessionsList.vue?vue&type=style&index=0&id=01b23916&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports